<script>
  import {push} from "svelte-spa-router";
  import { _ } from "svelte-i18n";
</script>

<div class="rowPodcast" on:click={() => push("/podcasts")}>
    <div
            class="divider-v family-divider"
            style=" margin-right: 16px;"
    />
    <div class="fit-image" >
        <img
                src="./images/dashboard/nah_dran.png"
                class="podcast imageBlur"
                alt="NAH DRAN"
        />
        <div class="headline-xs">Podcast</div>
    </div>
</div>

<style>
    .rowPodcast {
        display: flex;
        flex-direction: row;
        justify-content: right;
        margin-top: 24px;
        margin-bottom: 24px;
        width: 100%;
    }

    .podcast {
        object-fit: cover;
        height: 143px;
        width: 100%;
        margin-bottom: 8px;
        display: block;
    }

    .fit-image{
        width: 69%;
    }
    .family-divider {
            height: 166px;
        }
    @media only screen and (min-width: 530px) {
        .podcast {
        height: 270px;
        object-position: left bottom;
    }
        .family-divider {
            height: 293px;
        }
    }
    @media only screen and (min-width: 800px) {
        .family-divider {
            display: none;
        }


        .rowPodcast {
            margin-top: 48px;
            margin-bottom: 0;
        }
        
        .fit-image{
        width: 100%;
        }

        .podcast {
            height: 220px;
            margin-bottom: 16px;
        }
    }
    @media only screen and (min-width: 830px) {
        .podcast {
        height: 220px;
    }
    }
    @media only screen and (min-width: 1080px) {
        .podcast {
        height: 300px;
    }
    }
    @media only screen and (min-width: 1440px) {
        .podcast {
        height: 330px;
    }
    }
    @media only screen and (min-width: 1728px) {
        .podcast {
        height: 380px;
    }
    }
    @media only screen and (min-width: 1920px) {
        .podcast {
        height: 450px;
    }
    }
</style>